import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { modules } from 'src/app/globals';

@Component({
  selector: 'app-complete-request-dialog',
  templateUrl: './complete-request-dialog.component.html',
  styleUrls: ['./complete-request-dialog.component.css']
})
export class CompleteRequestDialogComponent implements OnInit {

  modules = modules;

  formGroup: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CompleteRequestDialogComponentInputData,
    private _ref: MatDialogRef<CompleteRequestDialogComponent>,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      note: null,
      abort: false
    });
  }

  abort(){
    this.formGroup.controls['abort'].setValue(true);
    this.close();
  }

  close(){
    this._ref.close(this.formGroup.value);
  }

  ngOnInit(): void {
  }

}

export class CompleteRequestDialogComponentInputData {
  title: string;
  addNote: boolean;
  noteHint: string;
}

export class CompleteRequestDialogComponentOutputData {
  note: string;
  abort: boolean;
}
